(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dct-dual-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dctTabsInit) return;
    window.__dctTabsInit = true;

    function activate(btn, focus) {
      var root = btn.closest('[data-dct-tabs]');
      if (!root || !root.classList.contains('dct-dual--tabs')) return;
      root.querySelectorAll('.dct-tabs__btn').forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
      });
      root.querySelectorAll('.dct-panel').forEach(function (p) {
        p.hidden = p.id !== btn.getAttribute('aria-controls');
      });
      if (focus) btn.focus();
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.dct-dual--tabs .dct-tabs__btn');
      if (btn) activate(btn, false);
    });

    document.addEventListener('keydown', function (e) {
      var btn = e.target.closest && e.target.closest('.dct-dual--tabs .dct-tabs__btn');
      if (!btn || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var list = Array.prototype.slice.call(btn.closest('.dct-tabs').querySelectorAll('.dct-tabs__btn'));
      var i = list.indexOf(btn) + (e.key === 'ArrowRight' ? 1 : -1);
      activate(list[(i + list.length) % list.length], true);
      e.preventDefault();
    });

    document.addEventListener('shopify:block:select', function (e) {
      var btn = document.querySelector('.dct-tabs__btn[data-block-id="' + e.detail.blockId + '"]');
      if (btn) activate(btn, false);
    });

    /* Onda branca ao clicar nos botões */
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('.dct-btn');
      if (!b) return;
      var r = b.getBoundingClientRect();
      var size = Math.max(r.width, r.height);
      var span = document.createElement('span');
      span.className = 'dct-ripple';
      span.style.width = span.style.height = size + 'px';
      span.style.left = (e.clientX - r.left - size / 2) + 'px';
      span.style.top = (e.clientY - r.top - size / 2) + 'px';
      b.appendChild(span);
      setTimeout(function () { span.remove(); }, 650);
    });

    /* Vista rápida */
    function money(cents, fmt) {
      var n = (cents / 100);
      var withDot = n.toFixed(2);
      var withComma = withDot.replace('.', ',');
      var noDec = Math.round(n).toString();
      fmt = fmt || ('{' + '{amount_with_comma_separator}' + '} €');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_with_comma_separator') return withComma;
        if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return noDec;
        return withDot;
      });
    }
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
    function imgUrl(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

    var modal;
    function getModal() {
      if (modal) return modal;
      modal = document.createElement('div');
      modal.className = 'dct-qv';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = '<div class="dct-qv__overlay" data-close></div><div class="dct-qv__box"><button type="button" class="dct-qv__close" data-close aria-label="Fechar">&times;</button><div class="dct-qv__body"></div></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
      return modal;
    }
    function closeModal() { if (modal) { modal.hidden = true; document.documentElement.style.overflow = ''; } }

    function render(p, root, url) {
      var m = getModal();
      var fmt = root.getAttribute('data-money-format');
      var addLabel = root.getAttribute('data-add-label') || 'Adicionar ao carrinho';
      var detailsLabel = root.getAttribute('data-details-label') || 'Ver detalhes';
      var soldLabel = root.getAttribute('data-soldout-label') || 'Esgotado';
      var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
      var imgs = (p.images || []).slice(0, 8);
      var box = m.querySelector('.dct-qv__box');
      box.innerHTML =
        '<button type="button" class="dct-qv__close" data-close aria-label="Fechar">&times;</button>' +
        '<div><img class="dct-qv__img" src="' + imgUrl(imgs[0], 900) + '" alt="' + esc(p.title) + '">' +
        (imgs.length > 1 ? '<div class="dct-qv__thumbs">' + imgs.map(function (s, i) { return '<img src="' + imgUrl(s, 120) + '" data-full="' + imgUrl(s, 900) + '" class="' + (i === 0 ? 'is-active' : '') + '" alt="">'; }).join('') + '</div>' : '') +
        '</div><div>' +
        '<h2 class="dct-qv__title">' + esc(p.title) + '</h2>' +
        '<div class="dct-qv__price"></div>' +
        (p.variants.length > 1 ? '<div class="dct-qv__field"><label>' + esc((p.options && p.options[0] && (p.options[0].name || p.options[0])) || 'Opção') + '</label><select class="dct-qv__variant">' +
          p.variants.map(function (x) { return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' — ' + soldLabel) + '</option>'; }).join('') +
          '</select></div>' : '') +
        '<div class="dct-qv__field"><label>Quantidade</label><input type="number" min="1" value="1" class="dct-qv__qty"></div>' +
        '<button type="button" class="dct-btn dct-btn--solid dct-qv__add" style="--dct-btn-bg:#2a3957;--dct-btn-text:#fff;background:#2a3957;color:#fff">' + esc(addLabel) + '</button>' +
        '<div class="dct-qv__msg" aria-live="polite"></div>' +
        '<a class="dct-qv__details" href="' + url + '">' + esc(detailsLabel) + '</a>' +
        '</div>';

      function current() {
        var sel = box.querySelector('.dct-qv__variant');
        var id = sel ? parseInt(sel.value, 10) : v.id;
        return p.variants.find(function (x) { return x.id === id; }) || v;
      }
      function paint() {
        var c = current();
        var pr = box.querySelector('.dct-qv__price');
        pr.innerHTML = (c.compare_at_price && c.compare_at_price > c.price)
          ? '<s>' + money(c.compare_at_price, fmt) + '</s><span class="is-sale">' + money(c.price, fmt) + '</span>'
          : '<span>' + money(c.price, fmt) + '</span>';
        var add = box.querySelector('.dct-qv__add');
        add.disabled = !c.available;
        add.textContent = c.available ? addLabel : soldLabel;
        if (c.featured_image && c.featured_image.src) box.querySelector('.dct-qv__img').src = imgUrl(c.featured_image.src, 900);
      }
      paint();
      var sel = box.querySelector('.dct-qv__variant');
      if (sel) sel.addEventListener('change', paint);
      box.querySelectorAll('.dct-qv__thumbs img').forEach(function (t) {
        t.addEventListener('click', function () {
          box.querySelector('.dct-qv__img').src = t.getAttribute('data-full');
          box.querySelectorAll('.dct-qv__thumbs img').forEach(function (o) { o.classList.toggle('is-active', o === t); });
        });
      });
      box.querySelector('.dct-qv__add').addEventListener('click', function () {
        var btn = this, msg = box.querySelector('.dct-qv__msg');
        var qty = Math.max(1, parseInt(box.querySelector('.dct-qv__qty').value, 10) || 1);
        btn.disabled = true; msg.textContent = '';
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: current().id, quantity: qty }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (res) {
            closeModal();
            var item = res.items ? res.items[0] : res;
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
            document.dispatchEvent(new CustomEvent('cart:build'));
            setTimeout(function () {
              var d = document.getElementById('CartDrawer');
              if (!d || !d.classList.contains('drawer--is-open')) window.location.href = root + 'cart';
            }, 700);
          })
          .catch(function (err) {
            msg.textContent = (err && (err.description || err.message)) || 'Não foi possível adicionar. Tente novamente.';
          })
          .finally(function () { btn.disabled = false; });
      });
      m.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      box.querySelector('.dct-qv__close').focus();
    }

    document.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-dct-quick]');
      if (!q) return;
      e.preventDefault();
      var root = q.closest('[data-dct-tabs]');
      var url = q.getAttribute('data-url');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      q.disabled = true;
      fetch(base + 'products/' + q.getAttribute('data-dct-quick') + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) { render(p, root, url); })
        .catch(function () { window.location.href = url; })
        .finally(function () { q.disabled = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dct-quickview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dctQuickView) return;
    window.__dctQuickView = true;

    function tpl() { return document.getElementById('dct-qv-extras'); }
    function money(cents, fmt) {
      var n = cents / 100, dot = n.toFixed(2), comma = dot.replace('.', ','), nodec = Math.round(n).toString();
      fmt = fmt || ('{' + '{amount_with_comma_separator}' + '} €');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_with_comma_separator') return comma;
        if (k.indexOf('no_decimals') > -1) return nodec;
        return dot;
      });
    }
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
    function img(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

    var modal;
    function getModal() {
      if (modal) return modal;
      modal = document.createElement('div');
      modal.className = 'dqv';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = '<div class="dqv__overlay" data-close></div><div class="dqv__box"></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
      return modal;
    }
    function close() { if (modal) { modal.hidden = true; document.documentElement.style.overflow = ''; } }

    function optionNames(p) {
      return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    }
    function optionValues(p, i) {
      var o = (p.options || [])[i];
      if (o && typeof o === 'object' && o.values) return o.values;
      var seen = [];
      p.variants.forEach(function (v) { var val = v.options[i]; if (seen.indexOf(val) < 0) seen.push(val); });
      return seen;
    }

    function open(p, url) {
      var t = tpl();
      var d = t ? t.dataset : {};
      var fmt = d.moneyFormat;
      var addLabel = d.addLabel || 'Adicionar ao carrinho';
      var soldLabel = d.soldoutLabel || 'Esgotado';
      var m = getModal();
      var box = m.querySelector('.dqv__box');
      var names = optionNames(p);
      var hasOptions = !(p.variants.length === 1 && p.variants[0].title === 'Default Title');
      var current = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      var chosen = current.options.slice();
      var imgs = (p.images || []).slice(0, 10);

      var html = '<button type="button" class="dqv__close" data-close aria-label="Fechar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 5l14 14M19 5L5 19"/></svg></button>';
      html += '<div class="dqv__grid"><div class="dqv__gallery">';
      html += '<div class="dqv__thumbs">' + imgs.map(function (s, i) {
        return '<button type="button" class="dqv__thumb' + (i === 0 ? ' is-active' : '') + '" data-src="' + img(s, 1000) + '"><img src="' + img(s, 160) + '" alt=""></button>';
      }).join('') + '</div>';
      html += '<div class="dqv__main"><img src="' + img(imgs[0], 1000) + '" alt="' + esc(p.title) + '"></div></div>';
      html += '<div class="dqv__info"><h2 class="dqv__title">' + esc(p.title) + '</h2><div class="dqv__price"></div>';
      html += '<div class="dqv__lines-slot"></div>';
      if (hasOptions) {
        names.forEach(function (n, i) {
          html += '<div class="dqv__opt"><span class="dqv__opt-label">' + esc(n) + '</span><div class="dqv__opt-values" data-index="' + i + '">' +
            optionValues(p, i).map(function (val) { return '<button type="button" class="dqv__val" data-value="' + esc(val) + '">' + esc(val) + '</button>'; }).join('') +
            '</div></div>';
        });
      }
      html += '<label class="dqv__qty">Quantidade <input type="number" min="1" value="1"></label>';
      html += '<button type="button" class="dqv__add"></button><div class="dqv__msg" aria-live="polite"></div>';
      html += '<div class="dqv__pay-slot"></div><div class="dqv__ship-slot"></div><div class="dqv__notice-slot"></div>';
      if (d.showDesc === 'true' && p.description) {
        var cleanDesc = String(p.description)
          .replace(/(<br\s*\/?>\s*)*<img[^>]*>(\s*<br\s*\/?>)*/gi, '')
          .replace(/<p[^>]*>(\s|&nbsp;)*<\/p>/gi, '')
          .replace(/Pierre Marseille/g, 'Maria Alcantara')
          .replace(/PIERRE MARSEILLE/g, 'MARIA ALCANTARA');
        html += '<div class="dqv__desc">' + cleanDesc + '</div>';
      }
      html += '<a class="dqv__details" href="' + url + '">' + esc(d.detailsLabel || 'Ver todos os detalhes') + '</a>';
      html += '</div></div>';
      box.innerHTML = html;

      if (t) {
        var frag = t.content;
        var lines = frag.querySelector('.dqv-lines'); if (lines) box.querySelector('.dqv__lines-slot').appendChild(lines.cloneNode(true));
        var pay = frag.querySelector('.dqv-pay'); if (pay) box.querySelector('.dqv__pay-slot').appendChild(pay.cloneNode(true));
        var ship = frag.querySelector('.dqv-ship'); if (ship) box.querySelector('.dqv__ship-slot').appendChild(ship.cloneNode(true));
        var notice = frag.querySelector('.dqv-notice'); if (notice) box.querySelector('.dqv__notice-slot').appendChild(notice.cloneNode(true));
      }
      var shipEl = box.querySelector('.dqv-ship');
      if (shipEl) {
        var left = document.createElement('span');
        left.className = 'dqv-ship__left';
        left.innerHTML = '<span class="dqv-ship__dot"></span><span class="dqv-ship__stock"></span>';
        shipEl.insertBefore(left, shipEl.firstChild);
      }

      function findVariant() {
        return p.variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      }
      function paint() {
        var v = findVariant();
        var pr = box.querySelector('.dqv__price');
        var base = v || current;
        var h = '';
        if (base.compare_at_price && base.compare_at_price > base.price) {
          var pct = Math.round((base.compare_at_price - base.price) * 100 / base.compare_at_price);
          h = '<s>' + money(base.compare_at_price, fmt) + '</s><span class="is-sale">' + money(base.price, fmt) + '</span>';
          if (d.showSave === 'true') h += '<span class="dqv__save">' + esc(d.saveLabel || 'Poupe') + ' ' + pct + '%</span>';
        } else {
          h = '<span>' + money(base.price, fmt) + '</span>';
        }
        pr.innerHTML = h;
        box.querySelectorAll('.dqv__opt-values').forEach(function (group) {
          var i = parseInt(group.getAttribute('data-index'), 10);
          group.querySelectorAll('.dqv__val').forEach(function (b) {
            var val = b.getAttribute('data-value');
            b.classList.toggle('is-active', val === chosen[i]);
            var test = chosen.slice(); test[i] = val;
            var ok = p.variants.some(function (x) { return x.available && x.options.every(function (o, j) { return o === test[j]; }); });
            b.classList.toggle('is-unavailable', !ok);
          });
        });
        var add = box.querySelector('.dqv__add');
        var avail = !!(v && v.available);
        add.disabled = !avail;
        add.textContent = avail ? addLabel : soldLabel;
        var st = box.querySelector('.dqv-ship__stock');
        if (st) {
          st.textContent = avail ? (d.instockLabel || 'Em stock') : soldLabel;
          box.querySelector('.dqv-ship__dot').classList.toggle('is-out', !avail);
        }
        if (v && v.featured_image && v.featured_image.src) setMain(img(v.featured_image.src, 1000));
      }
      function setMain(src) {
        box.querySelector('.dqv__main img').src = src;
        box.querySelectorAll('.dqv__thumb').forEach(function (th) { th.classList.toggle('is-active', th.getAttribute('data-src') === src); });
      }
      box.addEventListener('click', function (e) {
        var th = e.target.closest('.dqv__thumb');
        if (th) { setMain(th.getAttribute('data-src')); return; }
        var b = e.target.closest('.dqv__val');
        if (b) {
          var i = parseInt(b.parentNode.getAttribute('data-index'), 10);
          chosen[i] = b.getAttribute('data-value');
          paint();
        }
      });
      box.querySelector('.dqv__add').addEventListener('click', function () {
        var btn = this, msg = box.querySelector('.dqv__msg'), v = findVariant();
        if (!v) return;
        var qty = Math.max(1, parseInt(box.querySelector('.dqv__qty input').value, 10) || 1);
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        btn.disabled = true; msg.textContent = '';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (res) {
            close();
            var item = res.items ? res.items[0] : res;
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
            setTimeout(function () {
              var dr = document.getElementById('CartDrawer');
              if (!dr || !dr.classList.contains('drawer--is-open')) window.location.href = root + 'cart';
            }, 700);
          })
          .catch(function (err) { msg.textContent = (err && (err.description || err.message)) || 'Não foi possível adicionar. Tente novamente.'; })
          .finally(function () { btn.disabled = false; paint(); });
      });

      paint();
      m.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      box.scrollTop = 0;
      box.querySelector('.dqv__close').focus();
    }

    document.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-dct-quick]');
      if (!q) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var url = q.getAttribute('data-url');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      q.disabled = true;
      fetch(base + 'products/' + q.getAttribute('data-dct-quick') + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) { open(p, url); })
        .catch(function () { window.location.href = url; })
        .finally(function () { q.disabled = false; });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
